import { RouteConfig } from 'vue-router';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { TableName } from '@/enums/tableName';
import store from '@/store/store';
import { preparePaymentPackQuery } from '@/utils/preparePaymentPackQuery';
import PaymentPacks from '@/views/mainRoute/procedure/payments/PaymentPacks.vue';

export const procedurePaymentPacksRoute: RouteConfig = {
  path: '',
  name: 'procedurePaymentPacks',
  component: PaymentPacks,
  beforeEnter: (to, from, next) => {
    const entityType = TableName.procedure;
    const entityId = to.params.procedureId.toString();
    Promise.all([
      store
        .dispatch('setting/findPublic', {
          code: PublicSettings.CHILD_PROCEDURE_ID,
          entityType,
          entityId
        })
        .then(() => store.dispatch('paymentPack/list', preparePaymentPackQuery(to))),
      store.dispatch('setting/findPublic', {
        code: PublicSettings.PAYMENT_PACK_COLUMNS,
        entityType,
        entityId
      })
    ]).then(() => next());
  }
};
